import { fetchApi } from "../../data-layer/fetch-api";
import { UserAuthToken } from "../../auth/user-auth/auth-client";

export function getUserPersonalData(userAuthToken: UserAuthToken): Promise<{ id: string; email: string | undefined }> {
  const accessToken = userAuthToken.access_token;

  return fetchApi(`/storefront/shop/me`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: `Bearer ${accessToken}`,
    },
  });
}
